import React, { useEffect, useState } from "react";

import { connect } from "react-redux";
import * as actionTypes from "../../store/actions/actionTypes";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

import CartItem from "./CartItem";
import EmtyImage from "../../assets/Basket.png";

import styled from "styled-components";

const CartView = styled.div`
   {
    width: 100%;
    height: 100%;
  }
`;

const CartHeader = styled.div`
  width: 100%;
  height: 8%;
  padding-bottom: 1%;
`;
const CartBody = styled.div`
  width: 100%;
  height: 70%;
  background: white;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
`;
const CartFooter = styled.div`
  width: 100%;
  height: 21%;
  border-top: 2px solid #eee;
`;
const CartTitle = styled.h3`
  font-weight: 500;
  padding: 2% 0;
  margin: 0;
`;
const Total = styled.div`
  width: 100%;
  height: 20px;
  padding: 5px 0;
`;
const TotalTitle = styled.h3`
  margin: 0;
  padding: 0;
  float: left;
`;
const TotalValue = styled.h3`
  margin: 0;
  padding: 0;
  float: right;
`;
const CheckoutButton = styled.button`
  width: 100%;
  padding: 12px 0;
  margin: 10px 10px 0 0;
  font-weight: bold;
  font-size: 1em;
  background: #276fb7;
  border: none;
  color: white;
  cursor: pointer;
  border-radius: 5px;
`;

const CloseCart = styled.span`
  cursor: pointer;
  margin-right: 20px;
`;

function Cart(props) {
  const [cart, setCart] = useState([]);
  let items = JSON.parse(localStorage.getItem("cart") || "[]"),
    total = 0;

  const removeCartItemHandler = (itemId) => {
    const cart = JSON.parse(localStorage.getItem("cart") || "[]");

    console.log(itemId);
    const newCartItems = cart.filter((cart, id) => {
      return id !== itemId;
    });
    console.log(newCartItems);
    localStorage.setItem("cart", JSON.stringify(newCartItems));
    props.setCart(newCartItems);
  };

  const cartItemQntDcrHandler = (itemId) => {
    const newCartItems = [];
    JSON.parse(localStorage.getItem("cart") || "[]").map((cart, id) => {
      if (itemId == id) {
        if (cart.quantity > 1) {
          let newQuantity = cart.quantity - 1;
          let cartItem = {
            itemId: cart.itemId,
            quantity: newQuantity,
            price: cart.price,
            image: cart.image,
            name: cart.name,
          };
          newCartItems.push(cartItem);
        } else {
          newCartItems.push(cart);
        }
      } else {
        newCartItems.push(cart);
      }
    });

    localStorage.setItem("cart", JSON.stringify(newCartItems));
    props.setCart(newCartItems);
  };
  const cartItemQntIncHandler = (itemId) => {
    const newCartItems = [];
    JSON.parse(localStorage.getItem("cart") || "[]").map((cart, id) => {
      if (itemId == id) {
        let newQuantity = cart.quantity + 1;
        let cartItem = {
          itemId: cart.itemId,
          quantity: newQuantity,
          price: cart.price,
          image: cart.image,
          name: cart.name,
        };
        newCartItems.push(cartItem);
      } else {
        newCartItems.push(cart);
      }
    });

    localStorage.setItem("cart", JSON.stringify(newCartItems));
    props.setCart(newCartItems);
    items = newCartItems;
  };

  let cartItemsNew;
  let delivery_caharge = props.shop.deliveryCharge
    ? props.shop.deliveryCharge
    : localStorage.delivery_charge
    ? localStorage.delivery_charge
    : 25;
  if (props.cart.length > 0) {
    cartItemsNew = props.cart.map((cartItem, id) => {
      total += cartItem.price * cartItem.quantity;
      return (
        <CartItem
          key={id}
          cartItem={cartItem}
          id={id}
          removeCartItemHandler={removeCartItemHandler}
          cartItemQntIncHandler={cartItemQntIncHandler}
          cartItemQntDcrHandler={cartItemQntDcrHandler}
        />
      );
    });
  } else {
    cartItemsNew = (
      <img
        style={{ width: "100%", maxHeight: "100%", marginTop: "50px" }}
        src={EmtyImage}
        alt="image"
      />
    );
  }

  return (
    <CartView>
      <CartHeader>
        <CartTitle>
          <CloseCart onClick={props.closeModal}>
            <FontAwesomeIcon icon={faArrowLeft} />
          </CloseCart>
          Your Basket
        </CartTitle>
      </CartHeader>
      <CartBody>{cartItemsNew}</CartBody>
      {props.cart.length > 0 ? (
        <CartFooter>
          <Total>
            <TotalTitle>Subtotal</TotalTitle>
            <TotalValue>{total} TK</TotalValue>
          </Total>
          <Total>
            <TotalTitle>Delivery charge</TotalTitle>
            <TotalValue>{delivery_caharge} TK</TotalValue>
          </Total>
          <Total>
            <TotalTitle>Total</TotalTitle>
            <TotalValue>
              {total + parseInt(delivery_caharge)}
              TK
            </TotalValue>
          </Total>
          <CheckoutButton onClick={props.checkoutHandler}>
            Checkout
          </CheckoutButton>
        </CartFooter>
      ) : null}
    </CartView>
  );
}

const mapStateToProps = (state) => {
  return {
    cart: state.utils.cart,
    name: state.utils.name,
    shop: state.utils.shop,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setCart: (cart) => {
      dispatch({
        type: actionTypes.SET_CART,
        cart,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Cart);
